import './App.css';
import Home from './components/Home';
import { Navigate, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/login';
import VerifyEmail from './components/VerfyEmail';
import AuthSuccess from "./components/AuthSuccess";
import Signup from "./components/auth/Signup";
import Recover from "./components/auth/Recover";
import Handoff from "./components/auth/Handoff";
import LinkDevice from "./components/auth/LinkDevice";
import AuthBridge from "./components/auth/AuthBridge";
import SecuritySettings from "./components/settings/SecuritySettings";
import Terms from "./components/legal/Terms";
import Privacy from "./components/legal/Privacy";
import { hasSession } from "./authClient";

// "/" sends people where they belong: the studio if this browser has a
// session, otherwise sign-in. (It used to be the email sign-up form, which
// passkey accounts replace.)
function Start() {
  return <Navigate to={hasSession() ? "/home" : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthBridge />
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/register" element={<Navigate to="/signup" replace />} />
        <Route path="/recover" element={<Recover />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/auth/success" element={<AuthSuccess />} />
        <Route path="/auth/handoff" element={<Handoff />} />
        <Route path="/link" element={<LinkDevice />} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/settings/security" element={<ProtectedRoute><SecuritySettings /></ProtectedRoute>} />
        <Route path="/profile" element={<Navigate to="/settings/security" replace />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Start />} />
      </Routes>
    </div>
  );
}

export default App;
